import { memo } from 'react';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import './OpDateTimepicker.css';

export const OpDateTimepicker = memo((props) => {
  const {
    allowEdit = false,
    cssClass,
    format,
    timeFormat,
    label,
    showClearButton = false,
    value,
    min,
    max,
    onChange,
    enabled,
    ...rest
  } = props;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        marginRight: '10px',
        width: '100%',
      }}
    >
      {label && (
        <div
          style={{
            fontSize: '14px',
            color: '#6D6D73',
            marginBottom: '5px',
            marginRight: '10px',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </div>
      )}

      <div className="view-schedule-date-picker-wrapper">
        <DateTimePickerComponent
          value={value}
          format={format}
          timeFormat={timeFormat}
          showClearButton={showClearButton}
          allowEdit={allowEdit}
          strictMode={true}
          min={min}
          max={max}
          onChange={onChange}
          cssClass={cssClass}
          enabled={enabled}
          {...rest}
        />
      </div>
    </div>
  );
});
